export default __webpack_public_path__ + "static/media/37.b76ee5e2.svg";